export enum MerchantAccountStatus {
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
}

export interface MerchantPaymentAccount {
  last4: string;
  status: MerchantAccountStatus;
  connectedAt: string;
}

export interface ConnectNmiAccountInput {
  securityKey: string;
}
